var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagBrasil(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1133_3699)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.0244 26.0486C20.2175 26.0486 26.0487 20.2174 26.0487 13.0243C26.0487 5.83118 20.2175 0 13.0244 0C5.83124 0 6.10352e-05 5.83118 6.10352e-05 13.0243C6.10352e-05 20.2174 5.83124 26.0486 13.0244 26.0486Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0243 5.09619L23.7835 13.024L13.0243 20.9519L2.26514 13.024L13.0243 5.09619Z",
    fill: "#FFDA44"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0243 17.5545C15.5263 17.5545 17.5545 15.5263 17.5545 13.0243C17.5545 10.5224 15.5263 8.49414 13.0243 8.49414C10.5224 8.49414 8.49414 10.5224 8.49414 13.0243C8.49414 15.5263 10.5224 17.5545 13.0243 17.5545Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7592 12.7407C9.97147 12.7407 9.21123 12.8605 8.49561 13.0829C8.5273 15.5575 10.5422 17.5541 13.0243 17.5541C14.5592 17.5541 15.9147 16.7901 16.7342 15.6224C15.3322 13.8673 13.175 12.7407 10.7592 12.7407Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4705 13.8923C17.5251 13.6112 17.5545 13.3213 17.5545 13.0243C17.5545 10.5223 15.5263 8.49414 13.0244 8.49414C11.1575 8.49414 9.55493 9.62364 8.86139 11.2363C9.47445 11.1093 10.1092 11.0424 10.7593 11.0424C13.3905 11.0423 15.7708 12.1361 17.4705 13.8923Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1133_3699"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26.0486,
    height: 26.0486,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBrasil);
export default __webpack_public_path__ + "static/media/flag-brasil.3bc8d13e0134fb174cc4918ef1fa84b1.svg";
export { ForwardRef as ReactComponent };